import { FaqItemResource } from '../../../@blocks/Faq/Faq';
import { BlogPostResource } from '../../../@blog/BlogPost/BlogPost';
import { DepartmentDetailResource } from '../../../@departments/DepartmentDetail/DepartmentDetail';
import { ProductCategoryResource } from '../../../@products/ProductCategory/ProductCategory';
import { BrandItemStrapiResource } from '../../../Brand/Brand';
import { PageResource, PageType } from '../../../Page/Page';
import { StoreResource } from '../../../Store/Store';

export enum MeilisearchPageTypeResource {
    blog = 'blog',
    brand = 'brand',
    category = 'category',
    customPage = 'custom-page',
    department = 'department',
    faq = 'faq',
    page = 'page',
    store = 'shop',
}

export enum MeilisearchPageType {
    blog = 'blog',
    brand = 'brand',
    category = 'category',
    customPage = 'custom-page',
    department = 'department',
    faq = 'faq',
    page = 'page',
    store = 'store',
}

export type MeilisearchPageId = `${MeilisearchPageTypeResource}-${number}`;

export interface MeilisearchPageResource extends PageResource {
    _meilisearch_id: MeilisearchPageId;
}

export interface MeilisearchPageHitResource extends MeilisearchPageResource {
    fixedType: PageType | null;
}

export type MeilisearchBlogPostHitResource = MeilisearchPageResource & BlogPostResource;
export type MeilisearchBrandHitResource = MeilisearchPageResource & BrandItemStrapiResource;
export type MeilisearchCategoryHitResource = MeilisearchPageResource & ProductCategoryResource;
export type MeilisearchDepartmentHitResource = MeilisearchPageResource & DepartmentDetailResource;
export type MeilisearchFaqHitResource = MeilisearchPageResource & FaqItemResource;
export type MeilisearchStoreHitResource = MeilisearchPageResource & StoreResource;

export type MeilisearchPage = MeilisearchPageHitResource
| MeilisearchBlogPostHitResource
| MeilisearchBrandHitResource
| MeilisearchCategoryHitResource
| MeilisearchDepartmentHitResource
| MeilisearchFaqHitResource
| MeilisearchStoreHitResource
